var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M8.94393 16.4921C9.19387 16.7301 9.58948 16.7205 9.82755 16.4706C10.0656 16.2206 10.056 15.825 9.80607 15.5869L4.59656 10.6248L16.875 10.6248C17.2202 10.6248 17.5 10.3449 17.5 9.99977C17.5 9.65459 17.2202 9.37477 16.875 9.37477L4.59648 9.37477L9.80607 4.41252C10.056 4.17444 10.0656 3.77883 9.82755 3.52889C9.58948 3.27895 9.19387 3.26934 8.94393 3.50741L2.76149 9.39633C2.62072 9.53042 2.53742 9.70145 2.51161 9.87926C2.50399 9.91826 2.5 9.95855 2.5 9.99977C2.5 10.0411 2.50401 10.0814 2.51165 10.1205C2.53752 10.2982 2.6208 10.4691 2.76149 10.6031L8.94393 16.4921Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow_left_white.b87c95d891473fdc0b4334bef065361f.svg";
export { ForwardRef as ReactComponent };